import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { http, fmtViews } from "../lib/api";

const VKEY = "bpv_visitor_id";
export const visitorId = () => {
  let v = localStorage.getItem(VKEY);
  if (!v) {
    v = (crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/-/g, "");
    localStorage.setItem(VKEY, v);
  }
  return v;
};

export const LikeButton = ({ id, likes = 0 }) => {
  const [liked, setLiked] = useState(false);
  const [count, setCount] = useState(likes);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setCount(likes);
    http.get(`/media/${id}/like`, { params: { visitor_id: visitorId() } }).then((r) => setLiked(!!r.data?.liked)).catch(() => {});
  }, [id, likes]);

  const toggle = async () => {
    if (busy) return;
    const next = !liked;
    setBusy(true);
    setLiked(next);
    setCount((c) => Math.max(0, c + (next ? 1 : -1)));
    try {
      const r = await http.post(`/media/${id}/like`, { visitor_id: visitorId(), liked: next });
      setCount(r.data?.likes ?? 0);
    } catch {
      setLiked(!next);
      setCount((c) => Math.max(0, c + (next ? -1 : 1)));
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={toggle}
      aria-pressed={liked}
      data-testid="like-button"
      className={`group flex items-center gap-2 border px-4 py-2 uppercase tracking-widest transition-colors ${liked ? "border-rose-600 bg-rose-600 text-white" : "border-slate-700 text-slate-200 hover:border-rose-500 hover:text-white"}`}
    >
      <Heart size={15} className={`transition-transform group-active:scale-125 ${liked ? "fill-white" : ""}`} />
      <span data-testid="like-count">{fmtViews(count)}</span> {liked ? "Curtido" : "Curtir"}
    </button>
  );
};
